'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    categoryBlocks: (0, _functional.getElements)('.blg-Category', { context: el })
  };
  this.className = 'blg-Category_FixedHeader-active';

  var checkFixHeader = function checkFixHeader() {
    if (window.innerWidth < _utils.mediaBreakpoints.sm) {
      _this.els.categoryBlocks.forEach(function (categoryBlock) {
        var fixedHeader = (0, _functional.getElement)('.blg-Category_FixedHeader', {
          context: categoryBlock
        });

        var scrollY = window.scrollY || window.pageYOffset;

        var triggerPoint = (0, _utils.getOffsetTop)(categoryBlock);
        var triggerPointEnd = triggerPoint + categoryBlock.offsetHeight;

        fixedHeader.classList.toggle(_this.className, scrollY > triggerPoint && scrollY < triggerPointEnd);
      });
    }
  };

  window.addEventListener('scroll', checkFixHeader);
};

exports.default = _class;